import React, { createContext, useContext, useCallback, useMemo } from "react";
import { ICON_REGISTRY } from "../utils/iconRegistry";

const IconResolverContext = createContext(null);

export function IconResolverProvider({ children }) {
  /**
   * icon_id に対応するアイコンコンポーネントを返す
   * ICON_REGISTRY に登録されていない icon_id は null を返す
   */
  const getMenuIconComponent = useCallback((iconId) => {
    if (!iconId || typeof iconId !== "string") return null;
    return ICON_REGISTRY[iconId] ?? null;
  }, []);

  /**
   * 互換性のために残しているが、静的レジストリのため何もしない
   */
  const loadIconLibrariesForIconIds = useCallback(() => {}, []);

  const value = useMemo(
    () => ({
      getMenuIconComponent,
      loadIconLibrariesForIconIds,
    }),
    [getMenuIconComponent, loadIconLibrariesForIconIds]
  );

  return (
    <IconResolverContext.Provider value={value}>
      {children}
    </IconResolverContext.Provider>
  );
}

export function useIconResolver() {
  const ctx = useContext(IconResolverContext);
  if (!ctx) {
    throw new Error("useIconResolver must be used within IconResolverProvider");
  }
  return ctx;
}
